import React from 'react';
import { TTextValueTooltip } from './shared-types';
import { Divider, Text } from '../providers/harmony-scope/lazy-enablers';
import { SimpleTooltip } from './simple-tooltip';

const attainmentWeightStyle = {
  display: 'flex',
  flexDirection: 'row' as const,
  gap: '5px',
  flexWrap: 'wrap' as const,
};
const flexColumnStyle = {
  display: 'flex',
  flexDirection: 'column' as const,
};
const flexRowStyle = {
  display: 'flex',
  flexDirection: 'row' as const,
};

interface Iprops {
  data: TTextValueTooltip[];
  maxItemWidth?: number;
}

export const DividerSeparatedText = (props: Iprops) => {
  const { data, maxItemWidth = 90 } = props;

  return (
    <div style={attainmentWeightStyle}>
      {data.map((item, index, arr) => (
        <React.Fragment key={`${item.text}-dividedtext-key`}>
          <div style={{ ...flexRowStyle, maxWidth: `${maxItemWidth}px` }}>
            <div style={flexColumnStyle}>
              <Text appearance="small">
                {item.text}
                {item.tooltip && item.tooltipOnText && (
                  <SimpleTooltip isLargeTooltip={item.isLargeTooltip} heading={item.text}>
                    {item.tooltip}
                  </SimpleTooltip>
                )}
              </Text>
              <Text appearance="heading-6">{item.value}</Text>
            </div>
            {item.tooltip && !item.tooltipOnText && (
              <SimpleTooltip
                heading={item.tooltipHeading && item.tooltipHeading.trim() !== '' ? item.tooltipHeading : item.text}
                isLargeTooltip={item.isLargeTooltip}
              >
                {item.tooltip}
              </SimpleTooltip>
            )}
          </div>
          <div>{index < arr.length - 1 && <Divider orientation="vertical" />}</div>
        </React.Fragment>
      ))}
    </div>
  );
};
